window._utility = {
	'sortColumns': function sortColumns(cols) {
		return cols.sort().sort(compareColumns);
	}
}

function compareColumns(a, b) {
	if (a.indexOf('_') === 0 && b.indexOf('_') === 0) {
		if (a > b) {
			return 1;
		}
		if (b > a) {
			return -1;
		}
	}
	else if (a.indexOf('_') === 0) {
		return -1;
	}
	else if (b.indexOf('_') === 0) {
		return 1;
	}
	else {
		if (a > b) {
			return 1;
		}
		if (b > a) {
			return -1;
		}
	}
	return 0;
}


angular.module('app.directive.logdb', [])
	.directive('edmRepeatEndEvent', function(){
		return {
	        restrict: 'A',
	        link: function (scope, element, attr) {
	            if (scope.$last === true && !!attr.edmRepeatEndEvent) {
					scope.$emit(attr.edmRepeatEndEvent);
				}
			}
		}
	})
	.directive('queryInput', function ($compile, $parse, serviceTranslate, serviceLogdb, serviceSession, $timeout, serviceQueryAutoCompleteSupporter) {
		return {
			restrict: 'E',
			scope: {
				onLoading: '&',
				onLoaded: '&',
				onStatusChange: '&',
				onHead: '&',
				onTail: '&',
				ngTemplate: '=ngTemplate',
				ngPageSize: '&',
				ngQueryString: '=',
				ngFields: '=',
				ngPid: '=',
				onError: '&',
				onFailed: '&',
				onAccessKey: '=',
				modelChangeHandler: '&',
				queryChangeHandler: '&'
			},
			// FOR IE11
			template: '<textarea disabled style="height: 31px;" ng-model-options="{ updateOn: \'blur focusout\' }" ng-model="ngQueryString" ng-attr-placeholder="{{ \'$S_msg_QueryHere\' | translate }}" spellcheck="false" autosize autosize-max-height="145" accessKey="{{onAccessKey ? \'q\' : \'\'}}"></textarea>\
			<button ng-disabled="!isReady" class="search btn btn-primary btn-notransition"><i class="fa fa-search"></i> {{ "$S_str_Run" | translate}}</button>\
			<button class="stop btn btn-warning">{{ "$S_str_Stop" | translate}}</button>',
			link: function (scope, element, attrs) {
				var textarea = element.find('textarea');
				var queryCodeMirror;
				serviceQueryAutoCompleteSupporter.init().then(function() {
					queryCodeMirror = CodeMirror.fromTextArea(textarea[0],{
						lineNumbers: false,
						extraKeys: {
							"Ctrl-Space":"autocomplete"
						},
						lineWrapping: true,
						mode:{
							name:"edmquery", 
							"keywords": serviceQueryAutoCompleteSupporter.getCommandObject(),
							"autoCompleteSupporter": serviceQueryAutoCompleteSupporter
						},
						hintOptions:{
							closeOnUnfocus: true
						},
						theme: 'neat'

					});

					queryCodeMirror.display.input.textarea.addEventListener('keydown', function(e) {
						if (e.type === 'keydown' && ((e.ctrlKey || e.shiftKey) && e.keyCode === 13)) {
							e.preventDefault();
							search();
						} else {
							if(!!scope.queryChangeHandler){
								scope.queryChangeHandler();
							}
						}
					});

				});
				scope.isReady = true;

				function getQueryStringAndFilterIndex(str) {
					if(!angular.isString(str)) {
						str = '';
					}
					str = str.replace(/\n/gi, ' ').replace(/(\|)*(\s)*\$filter\$/gi, '| $filter$');
					var idx = str.indexOf('| $filter$');
					return {
						'string': str.replace(/\|\s\$filter\$/gi, ''),
						'index': idx
					}
				}

				textarea.on('keydown', function (e) {
					if (e.type === 'keydown' && ((e.ctrlKey || e.shiftKey) && e.keyCode === 13)) {
						e.preventDefault();
						search();
					}
				});

				element.find('.search').on('click', function () {
					search();
				});

				element.find('.stop').on('click', stop);

				function createdFn(m) {
					element.removeClass('loaded').addClass('loading');
					scope.isReady = true;
					//사용자 입력 쿼리 기록 넣기
					//var queryStr = getQueryStringAndFilterIndex(scope.ngQueryString).string;
					var savedQuery = queryCodeMirror.getValue();
					// var queryStr = getQueryStringAndFilterIndex(savedQuery).string;
					// var savedCursor = queryCodeMirror.getCursor();
					scope.ngQueryString = savedQuery;
					serviceLogdb.save(getQueryStringAndFilterIndex(savedQuery).string);
					// queryCodeMirror.setValue(savedQuery);
					// queryCodeMirror.setCursor(savedCursor);
					queryCodeMirror.refresh();
				}

				function startedFn(m) {
					scope.onLoading({
						'$msg': m
					});
				}

				function getResultFn(callback) {
					return function (m) {
						scope.modelChangeHandler({
							'$model': m.body.result, 
							'$field': m.body.field_order,
							// added in issue2513
							'$types': m.body.field_types
							//
						});
						if(!scope.$parent.$$phase){
							scope.$parent.$digest();
						}
						if (!!callback) {
							callback();
						}
					}
				}

				function onHead(helper) {
					scope.onHead({
						'$helper': helper
					});
				}

				function onTail(helper) {
					// var lastQuery = queryCodeMirror.getValue();
					// var savedCursor = queryCodeMirror.getCursor();
					scope.onTail({
						'$helper': helper
					});
					// queryCodeMirror.setValue(lastQuery);
					// queryCodeMirror.setCursor(savedCursor);
					queryCodeMirror.refresh();

				}

				function loadedFn(m) {
					element.removeClass('loading').addClass('loaded');
					scope.onLoaded({
						'$msg': m,
						'$inst': z
					});
					scope.isReady = true;
					if(!scope.$$phase){
						scope.$apply();
					}
				}

				function onStatusChangeFn(m) {
					scope.onStatusChange({
						'$msg': m,
						'$inst': z
					});
				}

				function onErrorFn(m) {
					element.removeClass('loading').addClass('loaded');
					scope.onError({
						'$msg': m
					});
					scope.isReady = true;
					if(!scope.$$phase){
						scope.$apply();
					}

				}

				function failedFn(raw) {
					element.removeClass('loading').addClass('loaded');
					console.log('raw:', raw)
					var errorType, errorNote;

					var rxType = /type=(\w*(-|_)?)*/;
					var rxNote = /note=(.*)/;

					if(angular.isArray(raw) && !!raw[0].errorCode) {
						if (rxType.test(raw[0].errorCode)) {
							errorType = raw[0].errorCode.match(rxType)[0].split('type=')[1];
						}
						if (rxNote.test(raw[0].errorCode)) {
							errorNote = raw[0].errorCode.match(rxNote)[0].split('note=')[1];
						}
					}

					scope.onFailed({
						'$raw': raw,
						'$type': errorType,
						'$note': errorNote
					});
					scope.isReady = true;
					if(!scope.$$phase){
						scope.$apply();
					}
				}

				var z;

				function newsearch() {
					var limit = parseInt(scope.$eval(scope.ngPageSize));
					z = serviceLogdb.create(parseInt(scope.ngPid));
					//var queryStr = getQueryStringAndFilterIndex(scope.ngQueryString).string;
					var queryStr = getQueryStringAndFilterIndex(queryCodeMirror.getValue()).string;
					

					if(queryStr.length == 0) {
						scope.isReady = true;
						if(!scope.$$phase){
							scope.$digest();
						}
						return;
					}

					// scope.ngFields = undefined;

					z.query(queryStr, limit)
						.created(createdFn)
						.started(startedFn)
						.loaded(loadedFn)
						.onStatusChange(onStatusChangeFn)
						.onHead(onHead)
						.onTail(onTail)
						.failed(failedFn)
						.onError(onErrorFn)
				}

				function search() {
					scope.isReady = false;
					// if(!scope.$$phase){
					// 	scope.$digest();
					// }
					textarea.trigger('blur');
					textarea.trigger('focusout');
					if (z != undefined) {
						serviceLogdb.remove(z, undefined, newsearch);
					}
					else {
						newsearch();
					}
				}

				function stop() {
					element.removeClass('loading').addClass('loaded');
					z.stop()
						.success(function () {
							queryCodeMirror.refresh();
							console.log('stopped')
						})
					//removed in issue#2679, null이 들어가면 어차피 바로 return함.
					// scope.onLoaded({
					// 	'$msg': null
					// });

					scope.isReady = true;
					if(!scope.$$phase){
						scope.$apply();
					}
				}

				element[0].offset = function (offset, limit, callback) {
					if (z == undefined) return;
					z.getResult(offset, limit, getResultFn(callback));
				}

				element[0].run = function (query_string) {
					queryCodeMirror.setValue(query_string);
					search();
				}

				element[0].isLoading = function() {
					return element.hasClass('loading') || false;
				}

				element[0].stop = function() {
					element.removeClass('loading').addClass('loaded');
				}

				element[0].dispose = function() {
					element.removeClass('loading').addClass('loaded');
					if (z == undefined) return;

					z.stop().success(function() {
						serviceLogdb.remove(z);
						z = null;
					});
				}

				element[0].getInstance = function () {
					return z;
				}

				element[0].bindBackgroundQuery = function (id, str, status) {
					queryCodeMirror.setValue(str);
					z = serviceLogdb.createFromBg(scope.ngPid, id, str, status);
					z.registerTrap(function () {
						console.log('registerTrap')
					})
						.created(createdFn)
						.started(startedFn)
						.loaded(loadedFn)
						.onStatusChange(onStatusChangeFn)
						.onHead(onHead)
						.onTail(onTail)
						.failed(failedFn)
						.onError(onErrorFn)

					if (status == 'Running') {
						element.removeClass('loaded').addClass('loading');
					}
				}

				element[0].setPristine = function () {
					z = null;
					//scope.ngQueryString = '';
					queryCodeMirror.setValue('');
				}

				element[0].getQueryStringAndFilterIndex = function() {
					//return getQueryStringAndFilterIndex(scope.ngQueryString);
					return getQueryStringAndFilterIndex(queryCodeMirror.getValue()).string;
				}
			}
		}
	})
	.directive('queryInputV4', function ($compile, $parse, serviceTranslate, serviceLogdb, serviceSession, $timeout, serviceQueryAutoCompleteSupporter) {
		return {
			restrict: 'E',
			scope: {
				onLoading: '&',
				onLoaded: '&',
				onStatusChange: '&',
				onHead: '&',
				onTail: '&',
				ngTemplate: '=ngTemplate',
				ngPageSize: '&',
				ngQueryString: '=',
				ngFields: '=',
				ngPid: '=',
				onError: '&',
				onFailed: '&',
				onAccessKey: '=',
				modelChangeHandler: '&',
				queryChangeHandler: '&'
			},
			// FOR IE11
			template: '<textarea disabled style="height: 93px;" ng-model-options="{ updateOn: \'blur focusout\' }" ng-model="ngQueryString" ng-attr-placeholder="{{ \'$S_msg_QueryHere\' | translate }}" spellcheck="false" autosize autosize-max-height="145" accessKey="{{onAccessKey ? \'q\' : \'\'}}"></textarea>',
			link: function (scope, element, attrs) {
				var textarea = element.find('textarea');
				var queryCodeMirror;
				serviceQueryAutoCompleteSupporter.init().then(function() {
					queryCodeMirror = CodeMirror.fromTextArea(textarea[0],{
						lineNumbers: false,
						extraKeys: {
							"Ctrl-Space":"autocomplete"
						},
						lineWrapping: true,
						mode:{
							name:"edmquery", 
							"keywords": serviceQueryAutoCompleteSupporter.getCommandObject(),
							"autoCompleteSupporter": serviceQueryAutoCompleteSupporter
						},
						hintOptions:{
							closeOnUnfocus: true
						},
						theme: 'neat'
					});

					queryCodeMirror.display.input.textarea.addEventListener('keydown', function(e) {
						if (e.type === 'keydown' && ((e.ctrlKey || e.shiftKey) && e.keyCode === 13)) {
							e.preventDefault();
							search();
						} else {
							if(!!scope.queryChangeHandler){
								scope.queryChangeHandler();
							}
						}
					});
				});
				scope.isReady = true;

				function getQueryStringAndFilterIndex(str) {
					if(!angular.isString(str)) {
						str = '';
					}
					str = str.replace(/\n/gi, ' ').replace(/(\|)*(\s)*\$filter\$/gi, '| $filter$');
					var idx = str.indexOf('| $filter$');
					return {
						'string': str.replace(/\|\s\$filter\$/gi, ''),
						'index': idx
					}
				}

				textarea.on('keydown', function (e) {
					if (e.type === 'keydown' && ((e.ctrlKey || e.shiftKey) && e.keyCode === 13)) {
						e.preventDefault();
						search();
					}
				});

				function createdFn(m) {
					element.removeClass('loaded').addClass('loading');
					scope.isReady = true;
					//사용자 입력 쿼리 기록 넣기
					//var queryStr = getQueryStringAndFilterIndex(scope.ngQueryString).string;
					var savedQuery = queryCodeMirror.getValue();
					// var queryStr = getQueryStringAndFilterIndex(savedQuery).string;
					// var savedCursor = queryCodeMirror.getCursor();
					scope.ngQueryString = savedQuery;
					serviceLogdb.save(getQueryStringAndFilterIndex(savedQuery).string);
					// queryCodeMirror.setValue(savedQuery);
					// queryCodeMirror.setCursor(savedCursor);
					queryCodeMirror.refresh();
				}

				function startedFn(m) {
					scope.onLoading({
						'$msg': m
					});
				}

				function getResultFn(callback) {
					return function (m) {
						scope.modelChangeHandler({
							'$model': m.body.result, 
							'$field': m.body.field_order,
							// added in issue2513
							'$types': m.body.field_types
							//
						});
						if(!scope.$parent.$$phase){
							scope.$parent.$digest();
						}
						if (!!callback) {
							callback();
						}
					}
				}

				function onHead(helper) {
					scope.onHead({
						'$helper': helper
					});
				}

				function onTail(helper) {
					// var lastQuery = queryCodeMirror.getValue();
					// var savedCursor = queryCodeMirror.getCursor();
					scope.onTail({
						'$helper': helper
					});
					// queryCodeMirror.setValue(lastQuery);
					// queryCodeMirror.setCursor(savedCursor);
					queryCodeMirror.refresh();

				}

				function loadedFn(m) {
					element.removeClass('loading').addClass('loaded');
					scope.onLoaded({
						'$msg': m,
						'$inst': z
					});
					scope.isReady = true;
					if(!scope.$$phase){
						scope.$apply();
					}
				}

				function onStatusChangeFn(m) {
					scope.onStatusChange({
						'$msg': m,
						'$inst': z
					});
				}

				function onErrorFn(m) {
					element.removeClass('loading').addClass('loaded');
					scope.onError({
						'$msg': m
					});
					scope.isReady = true;
					if(!scope.$$phase){
						scope.$apply();
					}

				}

				function failedFn(raw) {
					element.removeClass('loading').addClass('loaded');
					console.log('raw:', raw)
					var errorType, errorNote;

					var rxType = /type=(\w*(-|_)?)*/;
					var rxNote = /note=(.*)/;

					if(angular.isArray(raw) && !!raw[0].errorCode) {
						if (rxType.test(raw[0].errorCode)) {
							errorType = raw[0].errorCode.match(rxType)[0].split('type=')[1];
						}
						if (rxNote.test(raw[0].errorCode)) {
							errorNote = raw[0].errorCode.match(rxNote)[0].split('note=')[1];
						}
					}

					scope.onFailed({
						'$raw': raw,
						'$type': errorType,
						'$note': errorNote
					});
					scope.isReady = true;
					if(!scope.$$phase){
						scope.$apply();
					}
				}

				var z;

				function newsearch() {
					var limit = parseInt(scope.$eval(scope.ngPageSize));
					z = serviceLogdb.create(parseInt(scope.ngPid));
					//var queryStr = getQueryStringAndFilterIndex(scope.ngQueryString).string;
					var queryStr = getQueryStringAndFilterIndex(queryCodeMirror.getValue()).string;
					

					if(queryStr.length == 0) {
						scope.isReady = true;
						// if(!scope.$$phase){
						// 	scope.$digest();
						// }
						return;
					}

					// scope.ngFields = undefined;

					z.query(queryStr, limit)
						.created(createdFn)
						.started(startedFn)
						.loaded(loadedFn)
						.onStatusChange(onStatusChangeFn)
						.onHead(onHead)
						.onTail(onTail)
						.failed(failedFn)
						.onError(onErrorFn)
				}

				function search() {
					scope.isReady = false;
					// if(!scope.$$phase){
					// 	scope.$digest();
					// }
					textarea.trigger('blur');
					textarea.trigger('focusout');
					if (z != undefined) {
						serviceLogdb.remove(z, undefined, newsearch);
					}
					else {
						newsearch();
					}
				}

				function stop() {
					element.removeClass('loading').addClass('loaded');
					z.stop()
						.success(function () {
							queryCodeMirror.refresh();
							console.log('stopped')
						})
					//removed in issue#2679, null이 들어가면 어차피 바로 return함.
					// scope.onLoaded({
					// 	'$msg': null
					// });

					scope.isReady = true;
				}

				element[0].search = function () {
					search();
				}

				element[0].stopSearch = function () {
					stop();
				}

				element[0].offset = function (offset, limit, callback) {
					if (z == undefined) return;
					z.getResult(offset, limit, getResultFn(callback));
				}

				element[0].run = function (query_string) {
					queryCodeMirror.setValue(query_string);
					search();
				}

				element[0].isLoading = function() {
					return element.hasClass('loading') || false;
				}

				element[0].stop = function() {
					element.removeClass('loading').addClass('loaded');
				}

				element[0].dispose = function() {
					element.removeClass('loading').addClass('loaded');
					if (z == undefined) return;

					z.stop().success(function() {
						serviceLogdb.remove(z);
						z = null;
					});
				}

				element[0].getInstance = function () {
					return z;
				}

				element[0].bindBackgroundQuery = function (id, str, status) {
					queryCodeMirror.setValue(str);
					z = serviceLogdb.createFromBg(scope.ngPid, id, str, status);
					z.registerTrap(function () {
						console.log('registerTrap')
					})
						.created(createdFn)
						.started(startedFn)
						.loaded(loadedFn)
						.onStatusChange(onStatusChangeFn)
						.onHead(onHead)
						.onTail(onTail)
						.failed(failedFn)
						.onError(onErrorFn)

					if (status == 'Running') {
						element.removeClass('loaded').addClass('loading');
					}
				}

				element[0].setPristine = function () {
					z = null;
					//scope.ngQueryString = '';
					queryCodeMirror.setValue('');
				}

				element[0].getQueryStringAndFilterIndex = function() {
					//return getQueryStringAndFilterIndex(scope.ngQueryString);
					return getQueryStringAndFilterIndex(queryCodeMirror.getValue()).string;
				}
			}
		}
	})
	.directive('tableView', function ($compile, serviceUtility, $timeout) {
		return {
			restrict: 'A',
			require: ['ngModel'],
			scope: {
				'model': '=ngModel',
				'fieldOrder': '=',
				'displayType': '='
			},
			tranclude: true,
			link: function (scope, element, attrs, ctrl, transclude) {
				if( (typeof LOGPRESSO !== 'undefined') && LOGPRESSO.organizationParameters) {
					scope.weblink = (LOGPRESSO.organizationParameters['logpresso.auto_link'] !== "disabled");
				} else {
					scope.weblink = true;
				}
				if (element[0].children.length === 0) {
					if(angular.isObject(scope.displayType)) {
						var tmpl = angular.element('<thead>\
							<tr>\
								<th ng-repeat="col in sortedColumns track by $index">\
									<span ng-switch="getColumnType(col)">\
										<span class="qr-th-type" ng-switch-when=\'number\'>1</span>\
										<span class="qr-th-type" ng-switch-when=\'object\'><i class="fa fa-custom-brackets"></i></span>\
										<span class="qr-th-type" ng-switch-when=\'map\'><i class="fa fa-custom-brackets"></i></span>\
										<span class="qr-th-type" ng-switch-when=\'datetime\'><i class="fa fa-clock-o"></i></span>\
										<span class="qr-th-type" ng-switch-when=\'ip\'><i class="fa fa-sitemap"></i></span>\
										<span class="qr-th-type" ng-switch-when=\'null\'><i class="fa fa-question"></i></span>\
										<span class="qr-th-type" ng-switch-when=\'bool\'><i class="fa fa-check"></i></span>\
										<span class="qr-th-type" ng-switch-when=\'list\'>[]</span>\
										<span class="qr-th-type" ng-switch-when=\'blob\'>01</span>\
										<span class="qr-th-type" ng-switch-default>A</span>\
										{{col}}\
									</span>\
									<!--<span class="qr-th-type" ng-if="getColumnType(col) === \'number\'">1</span>\
									<span class="qr-th-type" ng-if="getColumnType(col) === \'string\'">A</span>\
									<span class="qr-th-type object" ng-if="getColumnType(col) === \'object\'"><i class="fa fa-custom-brackets" style="padding-left:1px;"></i></span>\
									<span class="qr-th-type" ng-if="getColumnType(col) === \'datetime\'"><i class="fa fa-clock-o"></i></span>\
									{{col}}-->\
								</th>\
							</tr>\
						</thead>\
						<tbody ><tr ng-repeat="row in model track by $index">\
							<td ng-class="{\'null-cell\' : row[col] === null || row[col] === undefined, \'text-right\':getColumnType(col) === \'number\' }" ng-repeat="col in sortedColumns track by $index"><span ng-bind-html="row[col] | crlf:weblink" style="min-height: 15px; display: inline-block;"></span></td>\
						</tr></tbody>');
					}
					else {
						var tmpl = angular.element('<thead><tr><th ng-repeat="col in sortedColumns track by $index">{{col}}</th></tr></thead>\
							<tbody><tr ng-repeat="row in model track by $index">\
								<td ng-class="{\'null-cell\' : row[col] === null || row[col] === undefined}" ng-repeat="col in sortedColumns track by $index" ng-bind-html="row[col] | crlf:weblink"></td>\
							</tr></tbody>');
					}
					$compile(tmpl, true)(scope);
					tmpl.appendTo(element);
				}

				//var watcher;
				scope.getColumnType = function(colname) {
					var colInfos = scope.displayType.columnInfo;
					if(Array.isArray(colInfos)) {
						for(var i = 0; i < colInfos.length; ++i) {
							if(colInfos[i].key == colname) {
								return colInfos[i].type;
							}
						}
					}
					else if(!!colInfos){
						var type = colInfos[colname];
						switch(type){
							case 'long':
							case 'int':
							case 'short':
							case 'double':
							case 'float':
								return 'number'; 
							case 'date':
								return 'datetime'; 
							case 'ipv4':
							case 'ipv6':
								return 'ip';
							default :
								return type;
						}
					}
				}

				function Manipulate(val) {
					var cols = [];
					var targetCols;

					if(angular.isObject(scope.fieldOrder) && scope.fieldOrder.enable && scope.fieldOrder.by == 'query') {
						// deprecated
						targetCols = serviceUtility.extractFieldOrderFromQuery(scope.fieldOrder.query);
					}
					if(angular.isObject(scope.fieldOrder) && scope.fieldOrder.enable && scope.fieldOrder.by == 'server') {
						targetCols = serviceUtility.sortColumns(JSON.parse(angular.toJson(val)), scope.fieldOrder.order);
					}
					else {
						val.forEach(function (row) {
							cols = cols.concat(Object.keys(row));
						});

						cols = cols.unique();
						if(cols.indexOf('$$hashKey') != -1) {
							cols.splice(cols.indexOf('$$hashKey'), 1);
						}
						cols = window._utility.sortColumns(cols);
						targetCols = cols.slice(0);
					}

					scope.sortedColumns = targetCols;

				}

				scope.$watch('model', function (val) {
					scope.sortedColumns = [];
					if (!val) return;
					if (val.length == 0) return;
					Manipulate(val);
				});
			}
		}
	})
	.directive('tableViewResizable', function ($compile) {
		return {
			restrict: 'A',
			require: ['ngModel'],
			scope: {
				'model': '=ngModel'
			},
			tranclude: true,
			link: function (scope, element, attrs, ctrl, transclude) {
				if( (typeof LOGPRESSO !== 'undefined') && LOGPRESSO.organizationParameters) {
					scope.weblink = (LOGPRESSO.organizationParameters['logpresso.auto_link'] !== "disabled");
				} else {
					scope.weblink = true;
				}
				if (element[0].children.length === 0) {
					var tmpl = angular.element('<thead><tr><th ng-repeat="(i,col) in sortedColumns">{{col}}\
						<div ng-hide="i == sortedColumns.length - 1" class="resizeHandler"></div>\
					</th></tr></thead>\
					<tbody >\
						<tr ng-repeat="row in model track by $index">\
							<td ng-repeat="col in sortedColumns track by $index" ng-bind-html="row[col] | crlf:weblink"></td>\
						</tr>\
					</tbody>');
					$compile(tmpl, true)(scope);
					tmpl.appendTo(element);
				}

				var isMouseDown = false;
				var isRightOver = false, isLeftOver = false;
				var left;
				var elH, elThs, elTh, elThNext, elThPrev;
				var wTable, wTh, wThNext, wThPrev;
				var prevLeft, prevX, prevNW, prevPW;

				function fnMousemove(e) {

					if(e.pageX > prevX) {
						// console.log( ' drag to --> ');

						elThNext.width(wThNext - e.pageX + left);

						// console.log( prevNW, elThNext.width(), wThNext - e.pageX + left )
						if(prevNW == elThNext.width()) {
							// console.log('over-->')
							isRightOver = true;
						} else {
							elTh.width(wTh + e.pageX - left);
							prevNW = elThNext.width();
							isRightOver = false;
						}

					}
					else if(e.pageX < prevX) {
						// console.log( ' drag to <-- ');

						if(!isRightOver || !isLeftOver) {
							if(prevLeft == elH.offset().left) {
								// console.log('---------');
								return;
							}
							else {
								prevLeft = elH.offset().left;
							}
						}

						elThNext.width(wThNext - e.pageX + left);

						if(prevNW == elThNext.width()) {
							// console.log('over<--')
							isLeftOver = true;
						} else {
							elTh.width(wTh + e.pageX - left);
							prevNW = elThNext.width();
							prevPW = elTh.width();
							isLeftOver = false;
						}

					}
					prevX = e.pageX;

				}

				function fnMouseup(e) {
					console.log('up', e.pageX);
					isMouseDown = false;

					// var total = 0;
					// var percmap = elThs.map(function(i, th) {
					// 	var val = parseFloat(( ($(th).width() + 5) / wTable * 100).toFixed(2))
					// 	$(th).css('width', val + '%');
					// 	total = total + val;
					// 	return val;
					// });
					// console.log(percmap, total)

					$(document).off('mousemove.resizeHandler').off('mouseup.resizeHandler').off("selectstart.resizeHandler");
				}

				element.on('mousedown.resizeHandler', function(e) {
					if(e.target.className === 'resizeHandler') {
						elH = $(e.target);
						elTh = $(e.target.parentNode);
						elThNext = elTh.next();
						elThPrev = elTh.prev();

						wTable = element.width();
						wTh = elTh.width();
						wThPrev = elThPrev.width();
						wThNext = elThNext.width();

						elThs = elTh.parent().children();
						elThs.each(function(i, th) {
							$(th).width($(th).width());
						});

						left = elH.offset().left;
						console.log('down', left, wTh, wTable);
						isMouseDown = true;

						$(document).on('mousemove.resizeHandler', fnMousemove).on('mouseup.resizeHandler', fnMouseup).on("selectstart.resizeHandler", function() { return false; });
					}
				})

				function Manipulate(val) {
					var cols = [];
					val.forEach(function (row) {
						cols = cols.concat(Object.keys(row));
					});

					cols = cols.unique();
					cols.splice(cols.indexOf('$$hashKey'), 1);
					cols = window._utility.sortColumns(cols);
					ctrl[0].$modelValue.__cols__ = cols.slice(0);
				}

				scope.$watch('model', function (val) {
					if (!val) return;
					if (val.length == 0) return;
					ctrl[0].$modelValue.__cols__ = [];
					Manipulate(val);
					scope.val = val;
				});
			}
		}
	})
	.directive('tableViewWithPager', function ($compile, serviceTranslate) {
		return {
			restrict: 'E',
			require: ['ngModel'],
			scope: {
				model: '=ngModel',
				ngTotalCount: '=',
				ngItemsPerPage: '=',
				ngPageSize: '=',
				onPageChange: '&',
				fieldOrder: '='
			},
			tranclude: true,
			compile: function compile(tElement, tAttrs, transclude) {
				var tbodystr = '';
				if (tElement[0].children.length !== 0) {
					tbodystr = tElement.children().html().toString();
					tElement[0].innerHTML = '';
				}
				return function postLink(scope, element, attrs, ctrl, transclude) {
					var htmlstr = '<div class="tbl-view-container">\
					<div class="pager-container clearfix">\
						<div class="pull-left status">{{ngTotalCount | number}} {{ "$S_str_ResultsFound" | translate }}</div>\
						<pager class="pull-left" style="line-height:12px"\
							ng-model="model"\
							ng-total-count="ngTotalCount"\
							ng-items-per-page="ngItemsPerPage"\
							ng-page-size="ngPageSize"\
							on-page-change="changePage($idx)"></pager>\
					</div>\
					<table table-view ng-model="model" show-index="true" field-order="fieldOrder" class="table table-top-seamless table-striped">'
						+ tbodystr +
						'</table>\
					</div>';

					var tmpl = angular.element(htmlstr);
					$compile(tmpl, true)(scope);
					tmpl.appendTo(element);

					scope.numCurrentPage = 0;
					scope.ngTotalCount = 0;

					//console.log(scope.ngItemsPerPage, scope.ngPageSize);
					scope.changePage = function (idx) {
						scope.numCurrentPage = idx;

						scope.onPageChange({
							'$idx': idx,
							'$model': scope.model
						});
					}

					element.find('pager')[0].reset();
					element.find('pager')[0].setThresholdWidth(10);

					element[0].reset = function() {
						scope.numCurrentPage = 0;
						scope.ngTotalCount = 0;
						element.find('pager')[0].reset();
					}
				}
			}
		}
	})
	.directive('queryResult', function ($compile, serviceUtility, $timeout, $q, $filter) {
		return {
			restrict: 'E',
			scope: {
				ngPage: '=',
				ngPageSize: '=',
				ngCols: '@',
				ngModel: '=',
				isCheckType: '@',
				ngQuery: '=',
				ngFields: '='
			},
			template: `
			<div style="position: relative;width: 100%;height: 100%;">
				<div style="position: absolute; bottom: 0; top: 0; left: 0; right: 0; overflow: hidden" class="qr-container">
					<div style="overflow:auto; position:absolute; top:34px;" class="cont mixin-absolute">
						<table style="table-layout:fixed; width:0;" ng-class="{ expandable: (numTotalColumn - numLimitColumn > 0) }" class="cmpqr table-striped">
						</table>
					</div>
					<div class="header" style="position:absolute; height:35px; left:0; top:0; right:0; overflow:hidden;">
					</div>
				</div>
			</div>`,
			link: function (scope, element, attrs) {
				if( (typeof LOGPRESSO !== 'undefined') && LOGPRESSO.organizationParameters) {
					scope.weblink = (LOGPRESSO.organizationParameters['logpresso.auto_link'] !== "disabled");
				} else {
					scope.weblink = true;
				}
				var qrContainer = element.find('.qr-container');

				if (attrs.ngCustomTemplate != undefined) {
					element.empty();
					var customEl = angular.element(scope[attrs.ngCustomTemplate]);
					element.append(customEl);

					$compile(customEl)(scope);
				}

				var el = element.find('.cont'); // jQuery way, document.querySelectorAll 이 plain javascript
				var elHeader = element.find('.header');
				var elBody = element.find('.cmpqr');
				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");
				el.on('scroll', (e) => {// jQuery의 on(event listen) 과 같음.
					elHeader[0].scrollLeft = el[0].scrollLeft;
				});


				function newSearch() {
					scope.numLimitColumn = 50;
					if(!scope.$$phase){
						scope.$apply();
					}
				}

/*				function adjustWidth(start ,end){
					if(!!adjusting){
						return;
					}
					var adjusting = true;

					var s = start;
					var e = end;
					// console.log('start = ' ,s );
					// console.log('end = ' , e);
					var tds = element[0].querySelectorAll('.cont tr:first-child td'); // body
					var thd = element[0].querySelectorAll('.header .qr-cell-header');  // header
					var thshadow = element[0].querySelectorAll('.shadow .qr-cell-header'); // shadow.
					
					Array.prototype.forEach.call(tds, (td, i) => {
						if(i < s || i > e){
							return;
						}

						var tdMax = `${Math.max(td.offsetWidth, thshadow[i].offsetWidth)}px`;
						if(!tdMax || tdMax === '0px' ){
							return;
						}

						thd[i].style.width = tdMax;
						
						if(td.offsetWidth < thd[i].offsetWidth) {
							td.style.minWidth = `${thd[i].offsetWidth}px`;
						}
						
					});
					if(!qrContainer.length){
						qrContainer = element.find('.qr-container');
					}
					qrContainer.css('opacity', 1);
					adjusting = false;

				}*/

				//scope.$watch('ngModel', function (newVal , oldVal) {
				element[0].applyChangedModel = function(changedModel, changedFields, changedFieldTypes, changedFontSize){
					// console.warn('========================> applyChangedModel')
					// console.warn(changedModel);
					// console.warn(changedFields);
					if (!angular.isArray(changedModel)) {
						return;
					} // 데이터가 배열이 아니면 리턴
					scope.ngModel = changedModel;
					if (scope.isCheckType == undefined) scope.isCheckType = false;

					if (!changedFontSize)
						changedFontSize = 1;

					var val = changedModel;
					ctx.font = '' + (10.71 * changedFontSize) + 'px Menlo, Monaco, Consolas, "Courier New", Roboto, "Apple SD Gothic Neo", "Malgun Gothic", "Nanum Gothic", "Helvetica Neue", Helvetica, Arial, sans-serif';
					var cols = new Object();
					var colarr = [];
					var colcount = 0;
					var rows = [];
					var idxwidth = 50;
					var tabwidth = ctx.measureText("        ").width;
					for (var i = 0; i < val.length; i++) {
						var row = val[i];
						var outrow = [];
						var j = 0;
						var n = scope.ngPage * scope.ngPageSize + 1 + i;
						var width = ctx.measureText("" + n).width + 30;
						if (width > idxwidth)
							idxwidth = Math.floor(width);
						for (var name in row) {
							var value = row[name];
							var col = cols[name];
							if (col === undefined) {
								col = cols[name] = {
									"idx": colcount++,
									"width": 50,
									"name": name,
									"type": "string",
								};
								colarr.push(col);
							}

							if (value !== null && value !== undefined) {
								var type = typeof value;
								var text = "" + value;
								if (type === "object") {
									col.type = "object";
									text = JSON.stringify(value);
									value = "" + $filter('crlfpre')(value, scope.weblink);
								}
								else if (type === "number") {
									col.type = "number";
									value = "" + value;
								}
								else if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}(\+|\-)\d{4}/.test(value))
									col.type = "datetime";
								else
									value = "" + $filter('crlfpre')(value, scope.weblink);
								
								var arr = text.split("\n");
								arr.forEach(function(line) {
									var width = 0;
									line.split("\t").forEach(function(l, i) {
										if (i > 0)
											width = Math.floor((width + tabwidth)/tabwidth) * tabwidth;
										width += ctx.measureText(l).width;
									});
									width+=17;
									if (width > col.width)
										col.width = Math.floor(width);
								});
							}
							outrow[col.idx] = value;
						}
						rows[i] = outrow;
					}

					colarr.sort(function (cola, colb) {
						var a = cola.name, b = colb.name, au = (a.charAt(0) == "_"), bu = (b.charAt(0) == "_");
						if (au && bu) {
							if (a > b)
								return 1;
							if (b > a)
								return -1;
						}
						else if (au)
							return -1;
						else if (bu)
							return 1;
						else if (a > b)
							return 1;
						else if (b > a)
							return -1;
						return 0;
					});

					if (!!changedFields) {
						var newcolarr = [];
						changedFields.forEach(function(name) {
							if (name in cols) {
								newcolarr.push(cols[name]);
							}
						});
						colarr.forEach(function(col) {
							if (newcolarr.indexOf(col) < 0)
								newcolarr.push(col);
						});
						colarr = newcolarr;
					}

					var colinfo = {
						"number":'<span class="qr-th-type">1</span>',
						"object":'<span class="qr-th-type"><i class="fa fa-custom-brackets"></i></span>',
						"map":'<span class="qr-th-type"><i class="fa fa-custom-brackets"></i></span>',
						"datetime":'<span class="qr-th-type"><i class="fa fa-clock-o"></i></span>',
						"ip":'<span class="qr-th-type"><i class="fa fa-sitemap"></i></span>',
						"null":'<span class="qr-th-type"><i class="fa fa-question"></i></span>',
						"bool":'<span class="qr-th-type"><i class="fa fa-check"></i></span>',
						"list":'<span class="qr-th-type">[]</span>',
						"blob":'<span class="qr-th-type">01</span>',
						"string":'<span class="qr-th-type">A</span>',
					};

					ctx.font = '900 ' + (12.6 * changedFontSize) + 'px Roboto, "Apple SD Gothic Neo", "Malgun Gothic", "Nanum Gothic", "Helvetica Neue", Helvetica, Arial, sans-serif';
					var totalwidth = idxwidth;
					colarr.forEach(function(col) {
						var width = ctx.measureText(" " + col.name).width + 34;
						if (width > col.width)
							col.width = Math.floor(width);
						totalwidth += col.width;

						var type = changedFieldTypes[col.name];
						switch(type){
							case 'long':
							case 'int':
							case 'short':
							case 'double':
							case 'float':
								col.type = 'number'; break;
							case 'date':
								col.type = 'datetime'; break;
							case 'ipv4':
							case 'ipv6':
								col.type = 'ip'; break;
							default :
								if (type in colinfo)
									col.type = type;
								else
									col.type = 'string';
						}
					});
					totalwidth+=32;
					var headhtml = '<div style="width:'+(totalwidth+100)+'px"><table style="table-layout:fixed; background-color:transparent; width:0; height:'+(changedFontSize < 1 ? 21 : 35)+'px;">';
					var rowhtml = '</colgroup><tbody><tr><td class="qr-cell-header" style="display:table-cell;">#</td>';
					var colhtml = '<colgroup><col style="width:'+idxwidth+'px;">';
					colarr.forEach(function(col) {
						colhtml += '<col style="width:'+col.width+'px;">';
						rowhtml += '<td class="qr-cell-header" style="display:table-cell;">' + colinfo[col.type] + ' ' + col.name + '</td>';
					});
					elHeader[0].innerHTML = headhtml + colhtml + rowhtml + '</tr></tbody></table></div>';
					var html = colhtml + '</colgroup><tbody style="background-color:white;">';
					for (var i = 0; i < rows.length; i++) {
						var n = scope.ngPage * scope.ngPageSize + 1 + i;
						rowhtml = '<tr><td style="overflow:hidden;">'+n+'</td>';
						var row = rows[i];
						for (var j = 0; j < colarr.length; j++) {
							var col = colarr[j];
							var value = row[col.idx];
							var clazz = "";
							if (value === null || value === undefined) {
								clazz = 'class="null-cell" ';;
								value = "";
							}
							if (value === "")
								value = "&nbsp;";
							rowhtml += '<td '+clazz+'style="overflow:hidden;'+(col.type == 'number' ? 'text-align:right;' : '')+'">' + value + '</td>';
						}
						html+=rowhtml + "</tr>";
					}
					//elBody[0].style.width = totalwidth + 'px';
					elBody[0].innerHTML = html + "</tbody>";

					scope.numTotalColumn = colcount;
					element.find('.qr-container').css('opacity', 1); 
					el.css('top', '' + (changedFontSize < 1 ? 20 : 34) + 'px');


/*					var cols = serviceUtility.sortColumns(JSON.parse(angular.toJson(scope.ngModel)), changedFields);

					if (cols.length > scope.numLimitColumn) {
						scope.numTotalColumn = cols.length;
					}

					scope.ngCols = cols.map(function (k) {
						return {
							guid: serviceUtility.generateType2(),
							name: k
						}
					});
					//added in issue2513
					for (var i = 0; i < scope.ngCols.length; i++) {
						var type = changedFieldTypes[scope.ngCols[i]['name']];
						switch(type){
							case 'long':
							case 'int':
							case 'short':
							case 'double':
							case 'float':
								scope.ngCols[i]['type'] = 'number'; continue;
							case 'date':
								scope.ngCols[i]['type'] = 'datetime'; continue;
							case 'ipv4':
							case 'ipv6':
								scope.ngCols[i]['type'] = 'ip'; continue;
							default :
								scope.ngCols[i]['type'] = type;
						}
					}

					if(!scope.ngModel.length) {
						return;
					}

					$timeout( function(){
						element[0].adjustWidth(((scope.numLimitColumn/scope.numLimitColumnInterval)-1) * 50  , scope.numLimitColumn);
					});*/
				};

				element[0].getColumns = function (fn) {
					var async = scope.$watch('ngCols', function () {
						fn.call(scope, scope.ngCols);
						async();
					});
				}

				// 로딩 인디케이터
				var loadingInd = angular.element('<div class="progress progress-striped active"><div class="bar" style="width: 100%;"></div></div>')
				element.prepend(loadingInd.hide());

				element[0].showLoadingIndicator = function () {
					if(!qrContainer.length){
						qrContainer = element.find('.qr-container');
					}
					qrContainer.css('opacity', 0);
					loadingInd.show();
				}

				element[0].showTable = function () {
					if(!qrContainer.length){
						qrContainer = element.find('.qr-container');
					}
					qrContainer.css('opacity', 1);
				}

				element[0].hideTable = function () {
					if(!qrContainer.length){
						qrContainer = element.find('.qr-container');
					}
					qrContainer.css('opacity', 0);
				}

				element[0].hideLoadingIndicator = function () {
					loadingInd.fadeOut();
				}

				element[0].newSearch = newSearch;
				element[0].adjustWidth = function() {};
				element[0].getCurrentColNum = function(){
					return scope.numLimitColumn;
				}
			}
		}
	});



// WEBPACK FOOTER //
// ./resources/WEB-INF/script/directive/directive.logdb.js